import axios from "../api/axios";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../LoadingSpinner";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import Order from "./Order";
// import Pusher from "pusher-js";

const Section = styled.section`
	margin-top: 100px !important;
`;

const Pending = () => {
	const params = useParams();
	const [orders, setOrders] = useState([]);
	const [loading, setLoading] = useState(false);

	const getOrders = useCallback(() => {
		const ids =
			localStorage.orders != null ? JSON.parse(localStorage.orders) : [];
		if (ids.length > 0) {
			setLoading(true);
			axios
				.post(
					`${
						process.env.REACT_APP_API
							? process.env.REACT_APP_API
							: "http://127.0.0.1:8000/api"
					}/pending-orders`,
					{
						table_no: params.tid,
						orders: ids,
						res: params.rid,
					}
				)
				.then((res) => {
					setOrders(res.data.data);
					setLoading(false);
				});
		}
	}, [params.tid, params.rid]);

	useEffect(() => {
		getOrders();
	}, [params.tid, getOrders]);

	// useEffect(() => {
	// 	const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
	// 		cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
	// 		encrypted: true,
	// 	});
	// 	const channel = pusher.subscribe(`branch.${params.rid}`);
	// 	channel.bind("status.changed", (data) => {
	// 		let o_orders = orders;
	// 		o_orders = o_orders.map((o) =>
	// 			o.id === data.id ? { ...o, progress: data.status } : o
	// 		);
	// 		setOrders(o_orders);
	// 	});
	// 	return () => {
	// 		pusher.unsubscribe(`branch.${params.rid}`);
	// 	};
	// }, [params.rid, orders]);

	return (
		<>
			<Helmet>
				<title>Your Orders</title>
			</Helmet>
			{loading && <LoadingSpinner asOverlay />}

			<div className="container-fluid">
				<div id="fda_app" className="row">
					<Section className="col-12 hid">
						<p color="#363636" className="littleline1">
							Previous Order
							<i className="fa-solid fa-arrows-rotate" onClick={getOrders}></i>
						</p>
					</Section>
					<section className="fda_section_product_tile col-12">
						{orders.map((o) => (
							<Order order={o} key={o.order_id} />
						))}
					</section>
				</div>
			</div>
		</>
	);
};

export default Pending;
